import React, { useContext,useEffect } from 'react';
import { Link } from 'react-router-dom';
import { AuthContext } from './../AuthContext';
import { site_url,site_url_img} from "./../config.js";
import { useNavigate } from "react-router-dom";

export default function Index() {
    const navigate = useNavigate();
    const { fulluser, user, login, setUser } = useContext(AuthContext);

    const handleLogout = () => {
      localStorage.removeItem('access_token'); 
      localStorage.removeItem('mpin');
      sessionStorage.setItem("mpin_verified", "false");
      setUser('');
      navigate("/");
  
    };
  return (
    <><div className="appHeader bg-primary text-light">
    <div className="left">
      <a
        href="#"
        className="headerButton"
        data-bs-toggle="modal"
        data-bs-target="#sidebarPanel"
      >
        <ion-icon name="menu-outline" />
      </a>
    </div>
    <div className="pageTitle" style={{ position: 'absolute', left: '56px', right: '10px', minWidth: 0, overflow: 'hidden', padding: '0 8px', textAlign: 'left' }}>
     <h4
      title={`Welcome ${fulluser?.shop_name || user}`}
      style={{color:'white',fontWeight:'700',fontSize:'18px',margin:0,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}
     >
      Welcome {fulluser?.shop_name || user}
     </h4>
    </div>
    <div className="right">
      {/* <Link  className="headerButton">
        <ion-icon className="icon" name="notifications-outline" />
        <span className="badge badge-danger">4</span>
      </Link> */}
     
    </div>
  </div>
    <div
    className="modal fade panelbox panelbox-left"
    id="sidebarPanel"
    tabIndex={-1}
    role="dialog"
  >
    <div className="modal-dialog" role="document">
      <div className="modal-content">
        <div className="modal-body p-0">
          {/* profile box */}
          <div className="profileBox pt-2 pb-2">
            <div className="image-wrapper">
              {fulluser && fulluser.shop_img != '' && (
              <img
                src={site_url_img+'/'+fulluser.shop_img}
                alt="image"
                className="imaged  w36"
              />
              )}
            </div>
            {fulluser && fulluser.username != '' && (
            <div className="in">
              
              <strong>{fulluser.username}-{fulluser.id}</strong>
              <div className="text-muted">{fulluser.phone}</div>
             {fulluser.gst != '' && (<strong>{fulluser.gst}</strong>)}
            </div>
            )}
            <a
              href="#"
              className="btn btn-link btn-icon sidebar-close"
              data-bs-dismiss="modal"
            >
              <ion-icon name="close-outline" />
            </a>
          </div>
          {/* * profile box */}
          {/* balance */}
          {/* <div className="sidebar-balance">
            <div className="listview-title">Balance</div>
            <div className="in">
              <h1 className="amount">$ 2,562.50</h1>
            </div>
          </div> */}
          {/* * balance */}
          {/* action group */}
          
          {/* * action group */}
          {/* menu */}
          <div className="listview-title mt-1">Menu</div>
          <ul className="listview flush transparent no-line image-listview">
            <li>
            <Link to="/home"  className="item">
                <div className="icon-box bg-primary">
                  <ion-icon name="pie-chart-outline" />
                </div>
                <div className="in">
                  Overview
              
                </div>
              </Link>
            </li>
            <li>
            <Link to="/Product"  className="item">
                <div className="icon-box bg-primary">
                  <ion-icon name="document-text-outline" />
                </div>
                <div className="in">Product</div>
              </Link>
            </li>
           
            <li>
            <Link to="/Transaction"  className="item">
                <div className="icon-box bg-primary">
                  <ion-icon name="card-outline" />
                </div>
                <div className="in">My Transaction</div>
              </Link>
            </li>
          </ul>
          {/* * menu */}
          {/* others */}
          <div className="listview-title mt-1">Others</div>
          <ul className="listview flush transparent no-line image-listview">
            <li>
            <Link to="/Settings"  className="item">
                <div className="icon-box bg-primary">
                  <ion-icon name="settings-outline" />
                </div>
                <div className="in">Settings</div>
              </Link>
            </li>
            
            <li>
              <a onClick={handleLogout} to="#"  className="item">
                <div className="icon-box bg-primary">
                  <ion-icon name="log-out-outline" />
                </div>
                <div className="in">Log out</div>
              </a>
            </li>
          </ul>
          {/* * others */}
          {/* send money */}
          
         
        </div>
      </div>
    </div>
  </div>
  </>
  )
}
